import api from '@/api/wechat'

const state = {

}

const actions = {
  getCompanyWxQrCode ({ commit }, params) {
    return api.getCompanyWxQrCode(params)
  },
  getCompanyWeChatTemplateMessageList (context, params) {
    return api.getCompanyWeChatTemplateMessageList(params)
  },
  getWeChatTemplateMessageInfo (context, params) {
    return api.getWeChatTemplateMessageInfo(params)
  },
  updateWeChatTemplateMessageStatus (context, params) {
    return api.updateWeChatTemplateMessageStatus(params)
  },
  createOrUpdateWeChatTemplateMessage (context, params) {
    return api.createOrUpdateWeChatTemplateMessage(params)
  },
  getCompanyWeChatTemplateAppAccount () {
    return api.getCompanyWeChatTemplateAppAccount()
  },
  createOrUpdateWeChatTemplateAppAccount (context, params) {
    return api.createOrUpdateWeChatTemplateAppAccount(params)
  },
  getCompanyWeChatAccountTemplateInfoByTemplateId (context, { templateId }) {
    return api.getCompanyWeChatAccountTemplateInfoByTemplateId(templateId)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
